import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {XYPlot, XAxis, YAxis, LineSeries, Hint, MarkSeries} from 'react-vis';
import {rgba} from 'polished';
import {isEmpty} from 'lodash';

import ContainerHeader from 'components/common/ContainerHeader';

import {containerStyles, colors} from 'styles/shared';

const StatsContainer = styled.div`
  width: 54.4rem;
  height: 38.7rem;
  margin-bottom: 5rem;
  ${containerStyles};
`;

const ContainerHeaderOverride = styled(ContainerHeader)`
  padding: 4rem 4.8rem;
`;

const DayOfWeek = styled.tspan`
  font-size: 1.2rem;
  color: ${colors.darkBlue_light};
`;

const DayOfMonth = styled.tspan`
  font-weight: bold;
  font-size: 1.6rem;
`;

const Month = styled.tspan`
  font-size: 1.4rem;
  color: ${colors.darkBlue_light};
`;

const HintContainer = styled.div`
  width: 11.8rem;
  height: 7.3rem;
  background: ${rgba(255, 255, 255, 0.9)};
  box-shadow: 0 0.83rem 2.48rem ${rgba(199, 196, 218, 0.3)};
  backdrop-filter: blur(0.33rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const HintTitle = styled.div`
  font-weight: bold;
  font-size: 1.3rem;
  line-height: 100%;
  color: ${colors.purple_dark};
  margin-bottom: 0.5rem;
`;

const HintText = styled.div`
  font-size: 1.3rem;
  line-height: 1.7rem;
  color: ${colors.darkBlue_light};
`;

CovidStatistics.propTypes = {
  statistics: PropTypes.array.isRequired
};

function CovidStatistics({statistics}) {
  const [graphData, setGraphData] = useState([]);

  const [hintValue, setHintValue] = useState<any>(null);

  useEffect(() => {
    let data: any = statistics.map((item, index) => {
      return {x: index + 1, y: item.value};
    });

    setGraphData(data);
  }, [statistics]);

  function tickFormater(value) {
    let date = statistics[value - 1].date;

    return (
      <tspan>
        <DayOfWeek x="0" dy="1em">
          {date.dayOfWeek}
        </DayOfWeek>
        <DayOfMonth x="0" dy="1.2em">
          {date.day}
        </DayOfMonth>
        <Month x="0" dy="1.4em">
          {date.month}
        </Month>
      </tspan>
    );
  }

  function onMouseLeave() {
    setHintValue(null);
  }

  function onNearestX(value) {
    setHintValue(value);
  }

  function render() {
    return (
      <StatsContainer>
        <ContainerHeaderOverride>COVID Statistics</ContainerHeaderOverride>

        <XYPlot width={544} height={260} margin={{left: 0, right: 0, top: 10, bottom: 100}} onMouseLeave={onMouseLeave}>
          <XAxis
            hideLine
            tickFormat={tickFormater}
            tickValues={[2, 3, 4, 5, 6, 7, 8, 9]}
            top={180}
            style={{line: {display: 'none'}}}
          />
          <YAxis hideLine hideTicks />

          <LineSeries
            color={colors.purple_dark}
            curve={'curveMonotoneX'}
            strokeWidth={3}
            data={graphData}
            onNearestX={onNearestX}
          />

          {!isEmpty(hintValue) && (
            <MarkSeries color={colors.purple_dark} strokeWidth={3} fill={'white'} data={[{...hintValue}]} />
          )}

          {hintValue && (
            <Hint value={hintValue} align={{vertical: 'top', horizontal: 'auto'}}>
              <HintContainer>
                <HintTitle>New cases</HintTitle>
                <HintText>{hintValue.y}</HintText>
              </HintContainer>
            </Hint>
          )}
        </XYPlot>
      </StatsContainer>
    );
  }

  return render();
}

export default CovidStatistics;
